<template>
  <div class="exchange md-layout md-layout-item md-size-80">

    <!--
    <template v-if="noRegisteredPairs()">
      <div class="app__no-data-msg">
        <md-card class="md-layout-item md-size-100">
          <md-card-content>
            <md-icon class="md-size-4x">autorenew</md-icon>
            <h2>{{ i18n.trd_no_exchange_pairs() }}</h2>
            <p>{{ i18n.trd_no_exchange_pairs_exp() }}</p>
          </md-card-content>
        </md-card>
      </div>
    </template>
    -->
    <template v-if="loadComplete && currentToken.length">
      <exchange-portfolio class="md-layout-item"
                          :currentAsset="currentToken"
                          :convertAsset="convertOpts.convertAsset"
                          :convertedAmount="convertOpts.convertedAmount"
                          @asset-change="setCurrentAsset"
      />
      <exchange-rates :currentAsset="currentToken" class="md-layout-item"/>
    </template>
    <template v-else>
      <div class="app__no-data-msg">
        <h3>{{ i18n.lbl_loading() }}</h3>
      </div>
    </template>
  </div>
</template>

<script>
  import ExchangePortfolio from './Exchange.Portfolio'
  import ExchangeRates from './Exchange.Rates'
  import { mapGetters, mapActions } from 'vuex'
  import { vuexTypes } from '@vuex/types'
  import { i18n } from '@js/i18n'
  import { multiply } from '@utils/math.util'
  import { ROUNDING_MODES } from '@const'
  import { pairsService } from '@api/pairs.service'
  import CurrencyRound from '@com/mixins/currency.round.mixin'
  import {isCryptoAsset} from '@utils/consts'

  export default {
    name: 'exchange',
    mixins: [CurrencyRound],
    components: {
      ExchangePortfolio,
      ExchangeRates
    },
    data: _ => ({
      convertOpts: {
        convertAsset: '',
        toConvert: undefined,
        convertedAmount: undefined
      },
      currentToken: null,
      loadComplete: false,
      validPairs: [],
      i18n
    }),
    async created () {
      await Promise.all([
        this.loadBalances(),
        this.setCurrentAsset(this.currentAsset, true),
        this.getOperatonalAccountId()
      ])
      this.getList(this.currentAsset)
      this.loadComplete = true
    },
    computed: {
      ...mapGetters([
        vuexTypes.accountBalances,
        vuexTypes.currentAsset,
        vuexTypes.operationalAccountId
      ])
    },
    mounted () {
      this.$on('convert-amount', function ({toConvert, convertAsset}) {
        if (toConvert !== undefined && toConvert > 0) {
          this.convertOpts.toConvert = toConvert
        } else if (toConvert === 0) {
          this.convertOpts.convertedAmount = 0
          this.convertOpts.convertAsset = ''
        }
        if (convertAsset !== undefined && convertAsset !== '') {
          this.convertOpts.convertAsset = convertAsset
        }
      })
    },
    methods: {
      ...mapActions({
        commitAsset: vuexTypes.COMMIT_CURRENT_ASSET,
        loadBalances: vuexTypes.GET_ACCOUNT_BALANCES,
        getOperatonalAccountId: vuexTypes.GET_OPERATIONAL_ACCOUNT_ID
      }),
      getList () {
        return this.validPairs
      },
      async setCurrentAsset (value, created = false) {
        if (value !== '') {
          this.currentToken = value
          this.validPairs = await pairsService.getPrices({source: this.currentToken, precision: 6})
        }
        if (created && (this.validPairs === undefined || this.validPairs.length === 0)) {
          const codes = Object.keys(this.accountBalances)
          const idx = codes.indexOf('UAH')
          this.currentToken = codes[idx !== -1 && idx < codes.length ? idx : 0] || null
          if (this.currentToken !== null) {
            this.validPairs = await pairsService.getPrices({source: this.currentToken, precision: 6})
          }
        }
        if (this.currentToken !== null) {
          await Promise.all([
            this.commitAsset(this.currentToken),
            this.loadBalances()
          ])
        }
      },
      noRegisteredPairs () {
        return this.loadComplete ? this.validPairs.length === 0 : false
      },
      convert () {
        let result = 0
        const pair = this.validPairs.find(pair => pair.quote === this.convertOpts.convertAsset)
        if (pair !== undefined) {
          const price = Number.parseFloat(pair.price)
          result = multiply(this.convertOpts.toConvert, price, ROUNDING_MODES.ROUND_DOWN)
        }
        if (isCryptoAsset(this.convertOpts.convertAsset)) {
          return this.roundCurrency2(result, this.convertOpts.convertAsset)
        } else {
          return this.roundCurrency(result, this.convertOpts.convertAsset)
        }
      },
      convertAmount () {
        if ((this.convertOpts.convertAsset !== undefined && this.convertOpts.convertAsset.length) &&
          (this.convertOpts.toConvert !== undefined && this.convertOpts.toConvert > 0)) {
          this.convertOpts.convertedAmount = this.convert()
        }
      }
    },
    watch: {
      'convertOpts.convertAsset': function () {
        this.convertAmount()
      },
      'convertOpts.toConvert': function () {
        this.convertAmount()
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~scss/variables';
  @import '~scss/mixins';

  .exchange {
    display: flex;
    justify-content: center;
    margin: auto;
    padding: 24px;
    @include border2();
    background-color: $default-white;
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/exchange/index/Exchange.Index.vue